module.exports = __webpack_public_path__ + "img/Villa_Borna_48.d98fa191.jpg";